import { lazy, Suspense } from 'react';

import './App.css';
import './responsive.css'
// import Home from './pages/Home';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Detailedblog from './components/Blog/Blogdetail';
const Home = lazy(()=> import("./pages/Home"));
const Contact = lazy(()=> import("./pages/Contact-us"));
const About = lazy(()=> import("./pages/About"));
const Work = lazy(()=> import("./pages/Work"));
const AboutUsPage = lazy(()=> import("./pages/About"));
const Cleaning = lazy(()=> import("./pages/Cleaning"));
const IotService = lazy(()=> import("./pages/IotService"));
const NotFound = lazy(()=> import("./pages/NotFound"));
const Partners = lazy(()=> import("./pages/Partners"));
const ThankYou = lazy(()=> import("./pages/ThankYou"));
const Facility = lazy(()=> import("./pages/Facility"));
const CareersBanner = lazy(()=> import("./pages/Career"));
const Technology = lazy(()=> import("./components/Technology/Technology"));
const Fullstack = lazy(()=> import("./pages/Fullstack"));
const Handyman = lazy(()=> import("./pages/Handyman"));
const Leadgeneration = lazy(()=> import("./pages/Lead-generation-intern"));
const Digitalmarket = lazy(()=> import("./pages/Digital-marketing-inter"));
const BusinessNa = lazy(()=> import("./pages/Business-development-na"));
const BusinessEA = lazy(()=> import("./pages/Business-development-ea"));
const AndroidDeveloper = lazy(()=> import("./pages/Android"));
const IosDeveloper = lazy(()=> import("./pages/Ios-developer"));
const Privacy = lazy(()=> import("./pages/Privacy"));
const Terms = lazy(()=> import("./pages/Terms"));
const Blog = lazy(()=> import("./pages/Blog"));
const DetailedPost = lazy(()=> import("./components/Blog/Detailblog"));
const ScrollToTop = lazy(()=> import("./components/ScrollToTop"));
const CaseStudyDetail = lazy(()=> import("./components/Work/Casestudy"));

function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/about",
      element: <About />,
    },
    {
      path: "/contact-us",
      element: <Contact/>,
    },
    {
      path: "/work",
      element: <Work/>
    },
    
    
    {
      path: "/workdetail/:id",
      element: <CaseStudyDetail/>
    },
    {
      path: "/about-us",
      element: <AboutUsPage/>
    },
    {
      path: "/services/iot-development-services",
      element: <IotService />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
    {
      path: "/company/partners",
      element: <Partners />,
    },
    {
      path: "/thank-you",
      element: <ThankYou />,
    },
    {
      path: "/solutions/facilities-management-software",
      element: <Facility/>,
    },
    {
      path: "/solutions/cleaning-management-software",
      element: <Cleaning/>,
    },
    {
      path: "/solutions/handyman-management-software",
      element: <Handyman/>,
    },
    {
      path: "/career",
      element: <CareersBanner/>
    },


    {
      path: "/full-stack-developer",
      element: <Fullstack/>
    },
  
    {
      path: "/lead-generation-intern",
      element: <Leadgeneration/>
    },
    {
      path: "/technology-stack",
      element: <Technology/>,
    },
    
    {
      path: "/digital-marketing-intern",
      element: <Digitalmarket/>
    },
    {
      path: "/business-development-na",
      element: <BusinessNa/>
    },
    {
      path: "/business-development-europe-apac",
      element: <BusinessEA/>
    },
    {
      path: "/android-developer",
      element: <AndroidDeveloper/>
    },
    {
      path: "/ios-developer",
      element: <IosDeveloper/>
    },
    {
      path: "/privacy-policy",
      element: <Privacy/>
    },
    {
      path: "/terms-conditions",
      element: <Terms/>
    },
    {
      path: "/blog",
      element: <Blog/>
    },
    {
      path: "/detailed-post/:id",
      element: <DetailedPost/>
     },
    //  {
    //   path: "/detailed-post/:id",
    //   element: <Detailedblog/>
    //  },
     

    //  {
    //   path: "/blogd",
    //   element: <Editi/>
    //  },
  ]);
  return (
    <>
          {/* <Suspense fallback={<div>Loading...</div>}> */}
          <Suspense >

     <RouterProvider router={router}>
     <ScrollToTop/>

      </RouterProvider>
      </Suspense>

    </>
  );
}

export default App;
